import classnames from 'classnames';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import AppStoreLink from 'components/icons/AppStoreLink';
import { isAndroidByOS, isMobileByOS } from 'externals/_tracking/dom/navigator';
import './AppStoreIconGroup.scss';

const AppStoreLinksDesktopView = ({
  datatestid,
  handleAppDownloadClick,
  desktopFlexClasses,
  storesImagesClasses,
}) => {
  return (
    <FlexContainer
      className={classnames('flex-mobile-col', desktopFlexClasses)}
    >
      <AppStoreLink
        datatestid={`${datatestid}-appStore`}
        handleAppDownloadClick={handleAppDownloadClick}
        appStoreClass={classnames('app-store-image', storesImagesClasses)}
        type="appleAppStore"
        isDesktop
      />
      <div className="padL16" />
      <div className="padB12 desktopOnlyHide" />
      <AppStoreLink
        datatestid={`${datatestid}-playStore`}
        handleAppDownloadClick={handleAppDownloadClick}
        appStoreClass={classnames('play-store-image', storesImagesClasses)}
        isDesktop
      />
    </FlexContainer>
  );
};

const AppStoreLinks = ({
  datatestid,
  handleAppDownloadClick,
  desktopFlexClasses,
  storesImagesClasses,
}) => {
  const isAndroidOS = isAndroidByOS();
  const appStoreClass = classnames({
    'app-store-image': !isAndroidOS,
    'play-store-image': isAndroidOS,
  });
  if (isMobileByOS()) {
    return (
      <AppStoreLink
        datatestid={datatestid}
        handleAppDownloadClick={handleAppDownloadClick}
        appStoreClass={appStoreClass}
        type={isAndroidOS ? 'playAppStore' : 'appleAppStore'}
      />
    );
  }
  return (
    <AppStoreLinksDesktopView
      datatestid={datatestid}
      handleAppDownloadClick={handleAppDownloadClick}
      desktopFlexClasses={desktopFlexClasses}
      storesImagesClasses={storesImagesClasses}
    />
  );
};

export default AppStoreLinks;
